import React from 'react';

import { PlanChooser, WikiWrapper } from 'apps/components';
import { BackButton } from 'components';
import { StartFreeTrail } from 'constants/subscription';

interface ChangePlanProps {
  activePlan: 'pro' | 'business';
  earlyUpgrade?: boolean;
  onClickCompanyForTeam: () => void;
  onClickCompanyForBusiness: () => void;
}

export const ChangePlan = ({
  earlyUpgrade,
  activePlan,
  onClickCompanyForTeam,
  onClickCompanyForBusiness,
}: ChangePlanProps) => {
  const chooseText = earlyUpgrade ? StartFreeTrail : 'Choose Plan';

  return (
    <WikiWrapper hiddenLogo className='relative'>
      <BackButton
        onClick={() => {
          history.back();
        }}
      />
      <PlanChooser
        hideSwitcher={true}
        teamChooseText={chooseText}
        activePlan={activePlan}
        businessChooseText={chooseText}
        onClickCompanyForTeam={() => {
          onClickCompanyForTeam();
        }}
        onClickCompanyForBusiness={() => {
          onClickCompanyForBusiness();
        }}
      />
    </WikiWrapper>
  );
};
